export default "__VITE_ASSET__DzFciR6R__"